import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/payment_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  number_cont: {
    model_name: 'Payment',
    column_type: 'string',
    column_name: 'number',
  },
  serial_number_cont: {
    model_name: 'Payment',
    column_type: 'string',
    column_name: 'serialNumber',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Payment',
      options: ['deposit', 'payment'],
    },
    model_name: 'Payment',
    column_name: 'kind',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Payment',
      options: ['pending', 'approved', 'rejected'],
    },
    model_name: 'Payment',
    column_name: 'state',
  },
  customer_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'Payment',
  },
  customer: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'Payment',
  },
  payment_allocations_payable_of_JushuitanOrder_type_shop_id_eq: {
    column_type: 'belongs_to',
    column_name: 'shop',
    extra: {
      model_name: 'JushuitanShop',
      value_column: 'shop_id',
    },
    model_name: 'JushuitanOrder',
  },
  shop: {
    column_type: 'belongs_to',
    column_name: 'shop',
    extra: {
      model_name: 'JushuitanShop',
      value_column: 'shop_id',
    },
    model_name: 'JushuitanOrder',
  },
  unallocated: {
    model_name: 'Payment',
    column_type: 'string',
    column_name: 'unallocated',
  },
  payment_account_id_eq: {
    column_type: 'belongs_to',
    column_name: 'payment_account',
    extra: {
      model_name: 'PaymentAccount',
      value_column: 'id',
    },
    model_name: 'Payment',
  },
  payment_account: {
    column_type: 'belongs_to',
    column_name: 'payment_account',
    extra: {
      model_name: 'PaymentAccount',
      value_column: 'id',
    },
    model_name: 'Payment',
  },
  payment_allocations_payable_of_JushuitanOrder_type_o_id_eq: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
    column_name: 'oId',
  },
  payment_allocations_payable_of_SalesOrder_type_number_eq: {
    model_name: 'SalesOrder',
    column_type: 'string',
    column_name: 'number',
  },
  creator_id_eq: {
    column_type: 'belongs_to',
    column_name: 'creator',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Payment',
  },
  creator: {
    column_type: 'belongs_to',
    column_name: 'creator',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Payment',
  },
  paid_on_month_eq: {
    model_name: 'Payment',
    column_type: 'string',
    column_name: 'eXTRACT(YEAR FROM paidOn) || "-" || LPAD(EXTRACT(MONTH FROM paidOn)::text, 2, "0")',
  },
}
export const formColumnsConfig = {
  'self': {
    'payment_account_id': { required: true, disabledUpdate: false },
    'serial_number': { required: true, disabledUpdate: false },
    'amount': { required: true, disabledUpdate: false },
    'paid_on': { required: true, disabledUpdate: false },
    'customer_id': { required: true, disabledUpdate: false },
    'kind': { required: true, disabledUpdate: false },
    'image': { required: false, disabledUpdate: false },
    'payment_allocations': { required: false, disabledUpdate: false },
    'remark': { required: false, disabledUpdate: false },
  },
  'payment_allocations': {
    'id': { required: false, disabledUpdate: true },
    'payable_id': { required: true, disabledUpdate: true },
    'payable_type': { required: true, disabledUpdate: true },
    'amount': { required: true, disabledUpdate: false },
    'deposit_ids': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Payment', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Payment', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
